import ModulePlanningBookingSlotModelBase from '../_generated/modelBases/module-planning-booking-slot-model-base';

export default class ModulePlanningBookingSlotModel extends ModulePlanningBookingSlotModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
